export const TOGGLE_CREATE_DIALOG = 'TOGGLE_CREATE_DIALOG'
export const UPDATE_DATA = 'UPDATE_DATA'
export const SUBSCRIBERS_REQUEST = 'subscribers_request'
export const SUBSCRIBERS_REQUEST_SUCCESS = 'subscribers_request_success'

export const DELETE_SUBSCRIBERS_REQUEST = 'delete_subscribers_request'
export const EDIT_SUBSCRIBERS_REQUEST = 'edit_subscribers_request'
export const ADD_SUBSCRIBER_REQUEST = 'ADD_SUBSCRIBER_REQUEST'
export const GET_SUBSCRIBER_REQUEST = 'GET_SUBSCRIBER_REQUEST'
export const GET_SUBSCRIBERS_EXPORT_DATA = 'GET_SUBSCRIBERS_EXPORT_DATA'
export const APPROVE_SUBSCRIBER = 'APPROVE_SUBSCRIBER'
export const MARK_AS_CORRECT_REQUEST = 'mark_as_correct_request'

export const SET_GROUPS = 'SET_GROUPS'
export const SET_FORM_STATE = 'SET_FORM_STATE'
export const SET_FORM_EMAIL_PHONE_STATE = 'SET_FORM_EMAIL_PHONE_STATE'
export const SEARCH_REQUEST = 'SEARCH_request'
export const SUBSCRIBERS_COUNT_FOR_STATUSES = 'SUBSCRIBERS_COUNT_FOR_STATUSES'

export const LAST_INVITATION_STATUS_PENDING = 2

/* Import Subscriber */
export const STEP_PROGRESS_ONE = 1
export const STEP_PROGRESS_TWO = 2
export const STEP_PROGRESS_THREE = 3
export const REMOVE_CSV_FILE = 'REMOVE_CSV_FILE'
export const VIEW_VALID_CSV_FORMAT = 'isOpenDialogViewValidCSVFormat'
export const WHAT_IS_CSV_FILE = 'isOpenDialogWhatIsCSVFile'
export const MORE_IMPORT_HELP = 'isOpenDialogMoreImportHelp'
export const BACK_TO_IMPORT_PAGE = 'isOpenDialogBackToImportPage'
export const CSV_FILE_PATH = '/assets/files/subscriber.csv'
export const CSV_FILE_PATH_WITH_AUTOMATED_CALL =
  '/assets/file_automated_call/subscriber.csv'
export const CSV_FILE_CARECHECK_PATH = '/assets/files_carechek/subscriber.csv'
export const CSV_NEW_SAMPLE_FILE_PATH =
  '/assets/files/CSV_Import_Audiences_Template-Basic_Import.csv'
export const PREVIEW_ITEMS_LIMIT = 10
export const STATUS_IS_IMPORTED = 'isImported'
export const STATUS_IS_IMPORTED_NOTFULLY = 'isImportedNotFully'
export const STATUS_IS_FAILED = 'isFailed'
export const STATUS_IS_EMPTY = 'statusIsEmpty'
export const MAX_CSV_SIZE = 1 // MB
export const STEP_ONE = 1 // Check CSV Validation
export const STEP_TWO = 2 // Import CSV
export const CHECK_CSV_VALIDATION = 'CHECK_CSV_VALIDATION'
export const IMPORT_CSV = 'IMPORT_CSV'
export const CHECK_IMPORT_PROCESS = 'CHECK_IMPORT_PROCESS'
export const IMPORT_TYPE_CSV = 'csv'
export const IMPORT_TYPE_GOOGLE = 'google'
export const GOOGLE_LOGIN = 'get_google_login'
export const GET_GOOGLE_CONTACTS = 'get_google_contacts'
export const IMPORT_GOOGLE_CONTACTS = 'import_google_contacts'
export const OPTION_GOOGLE_LOGIN = 'googleLogin'
export const SUBSCRIBER_NOT_PASS_PERMISSION = 'notPassPermission'
export const SUBSCRIBER_PASS_PERMISSION = 'passPermission'
export const TYPE_GROUP = 'group'
export const TYPE_SUBGROUP = 'subGroup'
export const TYPE_SUBSCRIBERS = 'subscribers'
export const IMPORT_CSV_LIMIT = 3000

export const PARAMS_BAD_CONTACT = 'bad_contact'
export const BAD_CONTACT = 2

export const IMPORT_CSV_TAB = 'IMPORT_CSV'
export const IMPORT_EXTERNAL_SOURCE_TAB = 'IMPORT_EXTERNAL_SOURCE'
export const ADD_ONE_BY_ONE_TAB = 'ADD_ONE_BY_ONE'

export const CATEGORY_PLACE_FOR_IMPORT_SCHOOL = 'Education'

export const VIA_APP = 0
export const VIA_PLACE = 1
export const VIA_ONE_ROSTER = 2

export const SubscriberSource = {
  VIA_APP: 0,
  VIA_PLACE_CSV_IMPORT: 1,
  VIA_EXTERNAL_ONE_ROSTER_VERACROSS: 2,
  VIA_APP_IOS: 3,
  VIA_APP_ANDROID: 4,
  VIA_PLACE_ONE_BY_ONE_IMPORT: 5,
  VIA_WIDGET: 6,
}

export const ALL_CONTACT = -1
export const VALIDATING_CONTACT = 0
export const VALID_CONTACT = 1
export const INVALID_CONTACT = 2
